// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__1Ir6r","crumb":"Breadcrumb_crumb__1JU-h"};